import { render, staticRenderFns } from "./AIChat_Explain.vue?vue&type=template&id=29170a36&scoped=true"
import script from "./AIChat_Explain.vue?vue&type=script&lang=js"
export * from "./AIChat_Explain.vue?vue&type=script&lang=js"
import style0 from "./AIChat_Explain.vue?vue&type=style&index=0&id=29170a36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29170a36",
  null
  
)

export default component.exports